export const PROJECT_STATUSES = ["Activo", "Pausado", "Finalizado", "Por confirmar", "En migración", "Suspendido"];
export const BILLING_STATUSES = ["Sin fecha", "Al día", "Próxima", "Vencida", "No aplica"];
export const PROJECT_BILLING_FREQUENCIES = ["Mensual", "Anual"];
export const DEVELOPMENT_TYPES = ["Web pública", "Web + panel admin", "CRM", "CRM + Automatizacion IA", "App FullStack", "Agente IA", "Automatización n8n", "E-commerce", "Plataforma / SaaS", "App Movil", "Otro"];
export const SERVICE_CYCLES = ["Mensual", "Anual", "Por consumo", "Pago único"];
export const SERVICE_STATUSES = ["Activo", "Pausado", "Finalizado", "Por confirmar"];
export const SERVICE_CATEGORIES = ["n8n / automatización", "API de IA", "WhatsApp / Meta", "Email transaccional", "Pagos", "Google APIs", "Hosting / servidor", "Base de datos", "Storage / archivos", "Dominio / SSL", "Mapas / geolocalización", "Otro"];

export const BOARD_COLUMNS = [
    { id: "pendiente", label: "Pendiente", className: "border-slate-300", dot: "bg-slate-400" },
    { id: "en_revision", label: "En revisión", className: "border-blue-300", dot: "bg-blue-500" },
    { id: "requiere_revision", label: "Requiere revisión", className: "border-red-300", dot: "bg-red-500" },
    { id: "finalizado", label: "Finalizado", className: "border-emerald-300", dot: "bg-emerald-500" },
];

export const PRIORITIES = [
    { id: "baja", label: "Baja" },
    { id: "media", label: "Media" },
    { id: "alta", label: "Alta" },
    { id: "critica", label: "Crítica" },
];

export const FUNCTIONAL_STATUSES = [
    { id: "no_revisado", label: "No revisado" },
    { id: "operativo", label: "Operativo" },
    { id: "degradado", label: "Funcionamiento degradado" },
    { id: "fuera_servicio", label: "Fuera de servicio" },
];

export const money = (value) => new Intl.NumberFormat("es-EC", { style: "currency", currency: "USD", minimumFractionDigits: 2 }).format(Number(value || 0));
export const number = (value) => new Intl.NumberFormat("es-EC", { maximumFractionDigits: 2 }).format(Number(value || 0));
export const dateLabel = (value) => {
    if (!value) return "—";
    const date = new Date(`${String(value).slice(0, 10)}T12:00:00`);
    return Number.isNaN(date.getTime()) ? "—" : new Intl.DateTimeFormat("es-EC", { day: "2-digit", month: "short", year: "numeric" }).format(date);
};

export const priorityClass = (priority) => ({
    baja: "bg-slate-100 text-slate-700",
    media: "bg-amber-100 text-amber-800",
    alta: "bg-orange-100 text-orange-800",
    critica: "bg-red-100 text-red-800",
}[priority] || "bg-slate-100 text-slate-700");

export const functionalClass = (status) => ({
    no_revisado: "bg-slate-100 text-slate-700",
    operativo: "bg-emerald-100 text-emerald-800",
    degradado: "bg-amber-100 text-amber-800",
    fuera_servicio: "bg-red-100 text-red-800",
}[status] || "bg-slate-100 text-slate-700");
